"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableRow = _interopRequireDefault(require("./TableRow"));

var _TableExpandedRow = _interopRequireDefault(require("./TableExpandedRow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Body inside Table
 */
var TableBody =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableBody, _React$Component);

  function TableBody() {
    _classCallCheck(this, TableBody);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableBody).apply(this, arguments));
  }

  _createClass(TableBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cellAlerts = _this$props.cellAlerts,
          columnKey = _this$props.columnKey,
          columns = _this$props.columns,
          customProps = _this$props.customProps,
          dataSource = _this$props.dataSource,
          editDirect = _this$props.editDirect,
          editRow = _this$props.editRow,
          eventHandlers = _this$props.eventHandlers,
          rowAction = _this$props.rowAction,
          rowAlerts = _this$props.rowAlerts,
          rowExpand = _this$props.rowExpand,
          rowKey = _this$props.rowKey,
          rowSelection = _this$props.rowSelection;
      var rows = [];

      for (var i = 0; i < dataSource.length; i++) {
        /**
         * This is doing a look a head to see if the next row will be in
         * focus and add a '-prefocus' class to the current row.
         * This is to address a styling issue where adding and removing border
         * during row editing causing the row height shifted by a pixel.
         */
        var nextRowData = dataSource[i + 1];
        var preFocusClassName = void 0;

        if (editRow && nextRowData && editRow.row === nextRowData[rowKey]) {
          preFocusClassName = '-prefocus';
        }

        rows.push(_react.default.createElement(_TableRow.default, {
          className: preFocusClassName,
          key: "row-".concat(dataSource[i][rowKey]),
          cellAlerts: cellAlerts,
          columnKey: columnKey,
          columns: columns,
          customProps: customProps,
          editDirect: editDirect,
          editRow: editRow,
          eventHandlers: eventHandlers,
          rowAction: rowAction,
          rowAlerts: rowAlerts,
          rowData: dataSource[i],
          rowExpand: rowExpand,
          rowKey: rowKey,
          rowIndex: i,
          rowSelection: rowSelection
        }));

        if (rowExpand) {
          rows.push(_react.default.createElement(_TableExpandedRow.default, {
            key: "expandedRow-".concat(dataSource[i][rowKey]),
            columns: columns,
            rowData: dataSource[i],
            rowExpand: rowExpand,
            rowIndex: i,
            rowKey: rowKey,
            rowSelection: rowSelection
          }));
        }
      }

      return _react.default.createElement("tbody", {
        className: (0, _classnames.default)(rowExpand ? 'has-row-expand' : '')
      }, rows);
    }
  }]);

  return TableBody;
}(_react.default.Component);

exports.default = TableBody;
TableBody.defaultProps = {};
TableBody.propTypes = {
  /**
   * Array of cell alert configs
   */
  cellAlerts: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Unique key for a row.
   */
  columnKey: _propTypes.default.string,

  /**
   * Array of column objects
   */
  columns: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Custom props to pass into table elements
   */
  customProps: _propTypes.default.object,

  /**
   * Data source for table
   */
  dataSource: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Object with direct edit config
   */
  editDirect: _propTypes.default.object,

  /**
   * Object with row edit config
   */
  editRow: _propTypes.default.object,

  /**
   * Table event handlers
   */
  eventHandlers: _propTypes.default.object,

  /**
   * Object with row action options
   */
  rowAction: _propTypes.default.object,

  /**
   * Array of row alert configs
   */
  rowAlerts: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Object with row expand options
   */
  rowExpand: _propTypes.default.object,

  /**
   * Unique key for a row.
   */
  rowKey: _propTypes.default.string,

  /**
   * Object with row selection config
   */
  rowSelection: _propTypes.default.object
};